import api from './authService';

// Get vendor consultation settings (public - for client)
export const getVendorConsultationSettings = async (vendorId) => {
  const response = await api.get(`/vendors/${vendorId}/consultation-settings`);
  return response.data;
};

// Client: Book a consultation
export const bookConsultation = async (data) => {
  const response = await api.post('/consultations', data);
  return response.data;
};

// Client: Active consultation with a vendor (pending or accepted)
export const getClientConsultationWithVendor = async (vendorId) => {
  const response = await api.get(`/consultations/with-vendor/${vendorId}`);
  return response.data;
};

// Vendor: Get consultation settings
export const getConsultationSettings = async () => {
  const response = await api.get('/vendor/consultations/settings');
  return response.data;
};

// Vendor: Check if Google Meet auto-generation is configured
export const getGoogleMeetConfigured = async () => {
  const response = await api.get('/vendor/consultations/google-meet-configured');
  return response.data;
};

// Vendor: Update consultation settings
export const updateConsultationSettings = async (data) => {
  const response = await api.put('/vendor/consultations/settings', data);
  return response.data;
};

// Vendor: List consultations
export const getConsultations = async (params = {}) => {
  const response = await api.get('/vendor/consultations', { params });
  return response.data;
};

// Vendor: Accept consultation
export const acceptConsultation = async (id, data) => {
  const response = await api.post(`/vendor/consultations/${id}/accept`, data);
  return response.data;
};

// Vendor: Reject consultation
export const rejectConsultation = async (id, data = {}) => {
  const response = await api.post(`/vendor/consultations/${id}/reject`, data);
  return response.data;
};

// Vendor: Mark consultation as completed
export const completeConsultation = async (id) => {
  const response = await api.post(`/vendor/consultations/${id}/complete`);
  return response.data;
};
